import { SegmentGroup as ArkSegmentGroup } from '@ark-ui/react';

import type { Scale2 } from '../../lib/types';
import { cn } from '../../lib/utils';

interface SegmentGroupRootProps extends ArkSegmentGroup.RootProps {
	size?: Scale2;
	variant?: 'default' | 'soft';
}

function SegmentGroupRoot({
	className,
	size = '2',
	variant = 'default',
	...props
}: SegmentGroupRootProps) {
	return (
		<ArkSegmentGroup.Root
			className={cn('pt-segment-group', className)}
			data-size={size}
			data-variant={variant}
			{...props}
		/>
	);
}

function SegmentGroupRootProvider(props: ArkSegmentGroup.RootProviderProps) {
	return <ArkSegmentGroup.RootProvider {...props} />;
}

function SegmentGroupLabel({ className, ...props }: ArkSegmentGroup.LabelProps) {
	return <ArkSegmentGroup.Label className={cn('pt-segment-group-label', className)} {...props} />;
}

function SegmentGroupIndicator({ className, ...props }: ArkSegmentGroup.IndicatorProps) {
	return (
		<ArkSegmentGroup.Indicator className={cn('pt-segment-group-indicator', className)} {...props} />
	);
}

function SegmentGroupItem({ className, ...props }: ArkSegmentGroup.ItemProps) {
	return <ArkSegmentGroup.Item className={cn('pt-segment-group-item', className)} {...props} />;
}

function SegmentGroupItemControl({ className, ...props }: ArkSegmentGroup.ItemControlProps) {
	return (
		<ArkSegmentGroup.ItemControl
			className={cn('pt-segment-group-item-control', className)}
			{...props}
		/>
	);
}

function SegmentGroupItemText({ className, ...props }: ArkSegmentGroup.ItemTextProps) {
	return (
		<ArkSegmentGroup.ItemText className={cn('pt-segment-group-item-text', className)} {...props} />
	);
}

function SegmentGroupItemHiddenInput(props: ArkSegmentGroup.ItemHiddenInputProps) {
	return <ArkSegmentGroup.ItemHiddenInput {...props} />;
}

const SegmentGroup = {
	Root: SegmentGroupRoot,
	RootProvider: SegmentGroupRootProvider,
	Label: SegmentGroupLabel,
	Indicator: SegmentGroupIndicator,
	Item: SegmentGroupItem,
	ItemControl: SegmentGroupItemControl,
	ItemText: SegmentGroupItemText,
	ItemHiddenInput: SegmentGroupItemHiddenInput,
	Context: ArkSegmentGroup.Context,
	ItemContext: ArkSegmentGroup.ItemContext
};

export { SegmentGroup };
